import React from 'react'
import s from './styles/UserListMessage.module.scss'
import InitialAvatar from '../../shared/components/InitialAvatar/InitialAvatar'
import { ReactComponent as MessagesIcon } from 'assets/icons/messages.svg'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow-left-line.svg'
import { ReactComponent as SearchIcon } from 'assets/icons/search_empty.svg'
import { ReactComponent as ClockIcon } from 'assets/icons/clock-full.svg'
import { ReactComponent as LaptopIcon } from 'assets/icons/laptop-clock.svg'
import { useUserListMessage } from './hooks/useUserListMessage'

export const UserListMessage = ({
	checkUserHandle,
	users,
	selectedId,
	isLoading = false,
}) => {
	const {
		items,
		search,
		setSearch,
		isCollapsed,
		isExpanded,
		showSearch,
		showOpenButton,
		handleUserClick,
		handleBackClick,
		handleMouseEnter,
		handleMouseLeave,
		handleOpenClick,
		isMobileLg,
	} = useUserListMessage({
		users,
		selectedId,
		onSelectUser: checkUserHandle,
		isLoading,
	})

	const wrapClassName = [
		s.wrap,
		isCollapsed ? s.wrap_collapsed : '',
		isExpanded ? s.wrap_expanded : '',
	]
		.filter(Boolean)
		.join(' ')

	return (
		<div
			className={wrapClassName}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
		>
			<div className={s.head}>
				<div className={s.head__info}>
					<div className={s.head__icon}>
						<MessagesIcon />
					</div>
					{!(isCollapsed && !isExpanded) && (
						<span className={s.head__text}>Your Inbox</span>
					)}
				</div>
				{isExpanded && !isMobileLg && (
					<button className={s.back} type="button" onClick={handleBackClick}>
						<ArrowIcon />
					</button>
				)}
			</div>

			<div className={s.content}>
				{showSearch && (
					<div className={s.search}>
						<div className={s.search__icon}>
							<SearchIcon />
						</div>
						<input
							type="text"
							className={s.search__input}
							placeholder="Search by name or email"
							value={search}
							onChange={e => setSearch(e.target.value)}
						/>
					</div>
				)}
				<div className={s.users}>
					{isLoading ? (
						<div className={s.usersLoading}>Loading...</div>
					) : (
						items.map((user, index) => {
							const isActive = selectedId === user.id
							const meta = user.activityMeta

							const activityClass =
								meta?.variant === 'recent'
									? s.user__data_recent
									: meta?.variant === 'today'
										? s.user__data_today
										: meta?.variant === 'old'
											? s.user__data_old
											: ''

							const userClassName = [
								s.user,
								isActive ? s.active : '',
								isActive ? s.user_active : '',
							]
								.filter(Boolean)
								.join(' ')

							const showDetails = !(isCollapsed && !isExpanded)

							return (
								<React.Fragment key={user.id}>
									<div
										onClick={() => handleUserClick(user)}
										className={userClassName}
									>
										<div className={s.user__inner}>
											<div className={s.user__icon}>
												<InitialAvatar
													name={user.name}
													studentId={user.id}
													student={user}
													size={showDetails ? 40 : 28}
													photoUrl={user.photoUrl}
													avatarKey={user.avatarKey}
													avatarSource={user.avatarSource}
												/>
											</div>
											{showDetails && (
												<div className={s.user__content}>
													<div className={s.user__info}>
														<p className={s.user__name}>{user.name}</p>
														<div className={s.user__meta}>
															{meta?.label && (
																<p
																	className={`${s.user__data} ${activityClass}`}
																>
																	{meta.icon === 'clock' && (
																		<span className={s.user__dataIcon}>
																			<ClockIcon />
																		</span>
																	)}
																	{meta.icon === 'laptop' && (
																		<span className={s.user__dataIcon}>
																			<LaptopIcon />
																		</span>
																	)}
																	<span className={s.user__dataText}>
																		{meta.label}
																	</span>
																</p>
															)}
															{user.unreadCount > 0 && (
																<span
																	className={s.new}
																	aria-label={`${user.unreadCount} unread`}
																>
																	<span className={s.new__text}>
																		{user.unreadCount > 99
																			? '99+'
																			: user.unreadCount}
																	</span>
																</span>
															)}
														</div>
													</div>
													<div className={s.user__descr}>
														<p className={s.user__text}>
															{user.hasConversation
																? user.lastMessage || '—'
																: 'Start conversation'}
														</p>
													</div>
												</div>
											)}
										</div>
									</div>
									{index < items.length - 1 && <div className={s.spacer} />}
								</React.Fragment>
							)
						})
					)}
				</div>
			</div>
			{showOpenButton && !isMobileLg && (
				<button className={s.open} type="button" onClick={handleOpenClick}>
					<ArrowIcon />
				</button>
			)}
		</div>
	)
}
